<template>
    <div class="link-justify-wrapper" ref="justifys">
        <slot></slot>
    </div>
</template>

<script>
    /**
     * @name：两端对齐父子组件父组件
     * @createdby：WangYue
     * @date：2018/11/26
     * @include：
     * @props：
     * @hooks：
     * @example：
     */

    import {findComponentsDownward, findComponentUpward} from "../../utils/dom";

    export default {
        name: "link-justify-wrapper",
        props: {
            data: {type: Array, require: true}           // 传递的数据数组
        },
        data() {
            return {
                modal: null
            }
        },
        methods: {
            /**
             * @method：reset
             * @param：el 父级元素对象
             * @returns：
             * @description：使子元素相对父级元素两端对齐，并且实现最后一样不足时向左对齐
             */
            reset() {
                // 父元素的总宽度
                const parentWidth = this.$refs.justifys.offsetWidth;
                // 子元素数组
                let childrenArry = findComponentsDownward(this, 'link-justify-item').map(item => item.$el);
                // 清除原有子元素上的所有样式
                for (let i = 0; i < childrenArry.length; i++) {
                    if (childrenArry[i].style) {
                        childrenArry[i].style = '';
                    }
                }
                // 每行子元素数组
                let rowChildrenArry = [];

                function f(arr) {
                    // 每行子元素的宽度总和
                    let rowChildrenWidth = 0;
                    // 每行子元素的间隔
                    let rowSpace = 0;
                    // 循环传入的数组
                    for (let i = 0; i < arr.length; i++) {
                        // 当前元素加后一个元素的宽度
                        let endWidth = 0;
                        // 判断标识
                        let isFalse = false;
                        // 计算当前元素们的宽度总和
                        rowChildrenWidth += arr[i].offsetWidth;
                        // 计算当前元素们加后一个元素的宽度总和
                        if (arr[i].nextSibling) {
                            endWidth = rowChildrenWidth + arr[i].nextSibling.offsetWidth
                        } else {
                            endWidth = rowChildrenWidth;
                        }
                        // 判断当前元素们宽度小于父元素宽度
                        if (rowChildrenWidth < parentWidth) {
                            isFalse = true;
                        }
                        // 判断当前元素加后一个元素宽度总和大于父元素宽度并且当前元素们宽度总和小于父元素宽度
                        if (rowChildrenWidth < parentWidth && parentWidth < endWidth) {
                            isFalse = true;
                        }
                        // 通过判断标识将满足需求的元素添加到每行子元素数组内并计算出元素间隔
                        if (isFalse) {
                            rowChildrenArry.push(arr[i]);
                            rowSpace = (parentWidth - rowChildrenWidth) / (rowChildrenArry.length - 1);
                        }
                    }
                    // 父元素宽度的3/4
                    let orSpace = parentWidth * 3 / 4;
                    // 判断当前元素们宽度总和小于父元素宽度的3/4时不进行两边对齐
                    if (rowChildrenWidth < orSpace) {
                        for (let i = 0; i < rowChildrenArry.length - 1; i++) {
                            rowChildrenArry[i].style = 'margin-right: 10px';
                        }
                    } else {
                        for (let i = 0; i < rowChildrenArry.length - 1; i++) {
                            rowChildrenArry[i].style = 'margin-right:' + rowSpace + 'px';
                        }
                    }

                }

                // 循环操作，直到子元素数组中没有元素为止
                do {
                    f(childrenArry);
                    childrenArry.splice(0, rowChildrenArry.length);
                    rowChildrenArry = [];
                } while (childrenArry.length > 0 && parentWidth > 0)

            },
        },
        watch: {
            data() {
                this.$nextTick(() => {
                    this.reset();
                });
            },
        },
        mounted() {
            // 为解决用display: none;方法隐藏的dom元素，无法通过offsetWidth获得父级元素宽度问题
            // 通过findComponentUpward方法，找到父级组件link-modal的vue实例
            this.modal = findComponentUpward(this, 'link-modal');
            // 判断父级组件link-modal是否存在，存在及监听组件的input方法，当input方法调用，就从新调用reset()的方法从新计算
            !!this.modal && this.modal.$on('input', () => this.$nextTick(() => this.reset()))
        },
    }
</script>

<style lang="scss">
    .link-justify-wrapper {
        box-sizing: border-box;
    }
</style>
